import React, { useState, useEffect } from 'react'
import WebMain from './WebMain'
import { useGwGoodsListQuery } from '../store/ReactWebSiteApi'
import { Card, Modal } from 'antd'
import WebGoodsSubTypeGoodsDesc from './WebGoodsSubTypeGoodsDesc'

const { Meta } = Card

function WebGoods() {
    const { data, isSuccess } = useGwGoodsListQuery({ eowg_e_id: '218' })
    const [list, setList] = useState([])
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                const raw = Array.isArray(data.Result) ? data.Result : []
                const arr = [...raw].sort((a, b) => +a.eowg_serial_number - +b.eowg_serial_number)
                setList(arr.filter((item) => item.eowg_state === '1'))
            } else {
                setList([])
            }
        }
    }, [data, isSuccess])
    const [descOpen, setDescOpen] = useState(false)
    const [activeItem, setActiveItem] = useState(null)

    return (
        <WebMain selectedKeys="goods">
            <div
                style={{
                    padding: '16px 12px 32px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    gap: 16,
                    width: '100%',
                    boxSizing: 'border-box',
                }}
            >
                {list.map((item) => (
                    <Card
                        key={item.eowg_id}
                        hoverable
                        style={{
                            width: '100%',
                            maxWidth: '100%',
                            boxShadow: '1px 1px 3px 0px rgba(0, 0, 0, 0.35)',
                        }}
                        styles={{ body: { padding: 12 } }}
                        cover={
                            <img
                                draggable={false}
                                alt=""
                                src={`../api/assets/images/application/${item.eowg_image_file.split(',')[0]}`}
                                style={{ width: '100%', height: 220, objectFit: 'cover', display: 'block' }}
                            />
                        }
                        onClick={() => {
                            setActiveItem(item)
                            setDescOpen(true)
                        }}
                    >
                        <Meta
                            title={<span style={{ fontSize: 16 }}>{item.eowg_name}</span>}
                            description={
                                <div
                                    style={{
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                        textOverflow: 'ellipsis',
                                        wordBreak: 'break-all',
                                        fontSize: 13,
                                    }}
                                >
                                    {item.eowg_sub_name}
                                </div>
                            }
                        />
                    </Card>
                ))}
                <Modal
                    open={descOpen}
                    title={null}
                    footer={null}
                    width="100%"
                    style={{ top: 0, maxWidth: '100vw', paddingBottom: 0 }}
                    styles={{ body: { maxHeight: '90vh', overflowY: 'auto', padding: 12 } }}
                    onCancel={() => {
                        setDescOpen(false)
                        setActiveItem(null)
                    }}
                    destroyOnHidden
                >
                    {activeItem ? <WebGoodsSubTypeGoodsDesc item={activeItem} /> : null}
                </Modal>
            </div>
        </WebMain>
    )
}

export default WebGoods
